import document from "./document";

const additionalDocument = `
    document {
        ${document}
    }
    id
    type
`;

export default additionalDocument;
